import React, { useState } from "react"
import * as Style from "./Comments.module.scss"
import Loader from "../UI/loader/Loader"
import SingleComment from "./single-comment/SingleComment"

const Comments = props => {
  const [colorTarget, setColorTarget] = useState(null)
  let content = (
    <div className={Style.commentLoaderWrapper}>
      <Loader style={Style.commentLoader} />
    </div>
  )

  const comments = props.commentData

  if (comments) {
    const mainPosts = comments.filter(comment => {
      return comment.attributes.position === "main"
    })

    const subPosts = comments.filter(comment => {
      return (
        comment.attributes.position === "reply-main" ||
        comment.attributes.position === "reply-sub"
      )
    })

    mainPosts.sort((a, b) => a.id - b.id)
    subPosts.sort((a, b) => a.id - b.id)

    content = (
      <div>
        {mainPosts.reverse().map(comment => {
          return (
            <SingleComment
              setColorTarget={setColorTarget}
              colorTarget={colorTarget}
              key={comment.id}
              id={comment.id}
              date_time={comment.attributes.date_time}
              user_name={comment.attributes.user_name}
              content={comment.attributes.content}
              strapi_id={props.strapi_id}
              discussion={props.discussion}
              mode="reply-main"
              subposts={subPosts}
            />
          )
        })}
      </div>
    )
  }

  return content
}

export default Comments
